import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  initialURL: '/',
  error: '',
  loading: false,
  message: '',
  redirectTo: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return { ...state, error: '', loading: true, message: '', redirectTo: null };
    }
    case FETCH_SUCCESS: {
      return { ...state, error: '', loading: false, message: action.payload, redirectTo: action.redirectTo };
    }
    case FETCH_ERROR: {
      return { ...state, loading: false, error: action.payload, message: '', redirectTo: null };
    }
    default:
      return state;
  }
};
